/* eslint-disable react/button-has-type */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';
import PropTypes from 'prop-types';
import view from '../../../../../../assets/img/icons/view.png';
import ViewReceipt from '../../../../shared/requisition/shared/ViewReceipt';
import CommonRequisitionDetail from '../../../../shared/requisition/shared/CommonRequistionDetails';
import ReactPaginate from 'react-paginate';

const AccountsLead = ({ requistions, load, payUser,totalPages, handlePageClick }) => {
  const [requisit, setRequisit] = useState({});
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [viewFile, setViewFile] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  // const getRequsition = (req) => {
  //   setRequisit(req);
  // };

  // const getFileRequsition = (req) => {
  //   setViewFile(req);
  //   if (req.imageUpload.split('.').pop() === 'document' || req.imageUpload.split('.').pop() === 'pdf') {
  //     window.open(req.imageUpload, '_blank');
  //   }
  // };
  const handleOpenModal = (requisition, modalType) => {
    setSelectedRequisition(requisition);
    setActiveModal(modalType);
    
    
    if (modalType === 'viewFile' && requisition.imageUpload) {
      setViewFile(requisition);
      const extension = requisition.imageUpload.split('.').pop();
      if (extension === 'document' || extension === 'pdf') {
        window.open(requisition.imageUpload, '_blank');
        return;
      }
    }
  };

  const handleCloseModal = () => {
    setActiveModal(null);
    setSelectedRequisition(null);
  };

  const requsitionList =
    requistions && requistions.length ? (
      requistions.map((requsition, i) => {
        return (
          <tr key={requsition.id}>
            <td>{i + 1}</td>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            <td>N{requsition.amount_in_digits}</td>
            <td>{requsition.amount_in_words}</td>

            <td>{requsition.account_approval}</td>
            <td>{requsition.manager_approval}</td>
            <td>{requsition.ceo_or_coo_approval}</td>
            <td>{requsition.in_favour_of}</td>
            <td>{requsition.requires_c_level_approval === false ? 'False' : 'True'}</td>
            <td>{requsition.requires_ceo_or_coo_approval === false ? 'False' : 'True'}</td>
            {requsition.created_at ? <td>{moment(requsition.created_at).format('MM/DD/YYYY')}</td> : 'N/A'}

            <td>{requsition.purpose}</td>
            <td>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <small onClick={() => payUser(requsition.id)}>
                <button className="btn btn-primary">Pay</button>
              </small>
            </td>
            <td>
              {requsition.account_payment_status === 'awaiting_payment' ? (
                <span className="badge badge-info" style={{ backgroundColor: 'blue' }}>
                  Awaiting Payment
                </span>
              ) : (
                <span className="badge badge-success" style={{ backgroundColor: 'green' }}>
                  Paid
                </span>
              )}
            </td>

            <td>
                <button
                  onClick={() => handleOpenModal(requsition, 'viewFile')}
                  style={{
                    border: '0',
                    backgroundColor: 'white',
                  }}
                >
                  <span className="view2">
                    <img src={view} alt="view" title="View" />
                  </span>
                </button>
            </td>

            <td>
                <button
                  onClick={() => handleOpenModal(requsition, 'details')}
                  style={{
                    border: '0',
                    backgroundColor: 'white',
                  }}
                >
                  <span className="view2">
                    <img src={view} alt="view" title="View" />
                  </span>
                </button>
            </td>
          </tr>
        );
      })
    ) : (
      <tr>
        <td>
          <p>No requisitions</p>
        </td>
      </tr>
    );

  return (
    <div className="card x-panel logs">
      <div className="table-responsive content">
        <table className="table copy-font">
          <thead>
            <tr>
              <th>#</th>
              <th>Amount In Digits</th>
              <th>Amount In Words</th>
              <th>Accounts Approval Status </th>
              <th>Manager Approval Status </th>
              <th>CEO/COO LEVEL Approval Status </th>
              <th>In Favor Of</th>
              <th>Requires C Level Approval?</th>
              <th>Requires CEO/COO Level Approval?</th>
              <th>Created At</th>
              <th>Purpose</th>
              <th>Pay</th>
              <th>Payment Status</th>
              <th>View Uploaded File</th>
              <th>View Details</th>
            </tr>
          </thead>

          {load ? <small>loading...</small> : <tbody>{requsitionList}</tbody>}
        </table>
        {activeModal === 'viewFile' && viewFile && (
        <div className="modal-root">
          <ViewReceipt 
            requisit={viewFile} 
            onClose={handleCloseModal}
          />
        </div>
      )}
      
      {activeModal === 'details' && selectedRequisition && (
        <div className="modal-root">
          <CommonRequisitionDetail 
            requisit={selectedRequisition} 
            onClose={handleCloseModal}
          />
        </div>
      )}
      </div>
      {totalPages > 1 ? (
        <ReactPaginate
          previousLabel="<<"
          nextLabel=">>"
          breakLabel="..."
          breakClassName="break-me"
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
      ) : null}


      <ToastContainer />
    </div>
  );
};

AccountsLead.propTypes = {
  requistions: PropTypes.shape(),
  load: PropTypes.bool,
  payUser: PropTypes.func,
};
export default AccountsLead;
